module.exports = __webpack_public_path__ + "img/Logo_double_row_blue@2x.0e9fc59d.png";